export const EXCMTEAMUSERDATA_CREATE_RESET = 'EXCMTEAMUSERDATA_CREATE_RESET'
export const EXCMTEAMUSERDATA_CREATE_SET_CREATED = 'EXCMTEAMUSERDATA_CREATE_SET_CREATED'
export const EXCMTEAMUSERDATA_CREATE_SET_ERROR = 'EXCMTEAMUSERDATA_CREATE_SET_ERROR'
export const EXCMTEAMUSERDATA_CREATE_SET_VIOLATIONS = 'EXCMTEAMUSERDATA_CREATE_SET_VIOLATIONS'
export const EXCMTEAMUSERDATA_CREATE_TOGGLE_LOADING = 'EXCMTEAMUSERDATA_CREATE_TOGGLE_LOADING'
